import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdsDashboardPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/ads/sponsored-products');
    }, [navigate]);

    return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
            <i className="bi bi-arrow-repeat spinning"></i>
            <p>Redirecting to Ads Assistant...</p>
        </div>
    );
};

export default AdsDashboardPage;